import React from 'react';
import PropTypes from 'prop-types';
import withSizes from 'react-sizes';
import Masonry from 'react-responsive-masonry';
import { connect } from "react-redux";
import { Link } from '../../routes';
import { ReviewCard } from "../index";
import { slugify } from "../../utils";

import {
  ReviewSection,
  ReviewHeading,
  ReviewsHeader,
  ReviewsButtonContainer,
  ReviewButton,
  ReviewsList,
  ReviewsItem,
  ReviewsListWrapper,
} from './styles';

const renderButton = (reviewsData, { name: hotelName, market: marketName, hotelId }) => (
  <Link
    route="hotel-reviews"
    params={{
      marketName: slugify(marketName),
      hotelName: slugify(hotelName),
      hotelId,
    }}
  >
    <a>
      <ReviewButton btnType="secondary">Read More ({reviewsData.total})</ReviewButton>
    </a>
  </Link>
);

const HotelReviews = ({ reviewsData, notMobile, isMobile, hotel }) => {
  const { reviewsList } = reviewsData;
  const amountOfReviewsToRender = isMobile ? reviewsList.slice(0, 2) : reviewsList;
  return (
    <ReviewSection>
      <ReviewsHeader>
        <ReviewHeading>What Dayaxers think...</ReviewHeading>
        {notMobile && reviewsData.total > 1 && renderButton(reviewsData, hotel)}
      </ReviewsHeader>
      <ReviewsListWrapper>
        <ReviewsList>
          <Masonry columnsCount={isMobile ? 1 : 2} gutter={isMobile ? '0' : '20px'}>
            {amountOfReviewsToRender.map(review => {
              const { id, checkInDate, rating, description, name } = review;

              return (
                <ReviewsItem key={id}>
                  <ReviewCard date={checkInDate} rating={rating} description={description} author={name} />
                </ReviewsItem>
              )
            })}
          </Masonry>
        </ReviewsList>
      </ReviewsListWrapper>
      {<ReviewsButtonContainer>{isMobile && reviewsData.total > 1 && renderButton(reviewsData, hotel)}</ReviewsButtonContainer>}
    </ReviewSection>
  );
};

HotelReviews.propTypes = {
  reviewsData: PropTypes.instanceOf(Object),
  hotel: PropTypes.instanceOf(Object),
  notMobile: PropTypes.bool,
  isMobile: PropTypes.bool,
};

const mapSizesToProps = ({ width }) => ({
  notMobile: width >= 768,
  isMobile: width < 768,
});

const mapStateToProps = state => ({
  hotel: state.userProduct.hotel,
});

export default withSizes(mapSizesToProps)(connect(mapStateToProps)(HotelReviews));
